import React from 'react'
import PropTypes from 'prop-types'
import SelectBackBtn from '../BackButton/SelectBackBtn'

const CompositionsList = ({
  children,
  listLimitClass = '',
  listSubtitle,
  listTitle,
  mainModClass = '',
}) => (
  <div className={`composition_row ${mainModClass}`}>
    {/* if you need to disable it please add class disable_mod to composition_row */}
    {listTitle && (
      <h2
        className={`section_title ${
          !listSubtitle ? 'genres_mod' : 'offset_mod title_step_left_mod songs_mod'
        }`}
      >
        {listSubtitle && (
          <div className="section_title_step">
            <span className="section_title_number">2</span>
          </div>
        )}
        {listTitle}
      </h2>
    )}
    {listSubtitle && (
      <span className="section_subtitle offset_mod v1_mod">{listSubtitle}</span>
    )}
    <ul className={`composition_list ${listLimitClass}`}>{children}</ul>
  </div>
)

export default CompositionsList

CompositionsList.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  listLimitClass: PropTypes.string,
  listSubtitle: PropTypes.string,
  listTitle: PropTypes.string.isRequired,
  mainModClass: PropTypes.string,
}
